/* unplugin-vue-components disabled */import { render } from "./invited.vue?vue&type=template&id=50882020&scoped=true"
import script from "./invited.vue?vue&type=script&lang=js"
export * from "./invited.vue?vue&type=script&lang=js"

import "./invited.vue?vue&type=style&index=0&id=50882020&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50882020"]])

export default __exports__